import React, { useContext } from "react";
import Swal from "sweetalert2";
import { UserConfigContext } from "../../context/UserConfigContext";

const PriceConsultationButton = ({
  children = "Precio a consultar",
  className = "",
  modalTitle = "Precio a consultar",
}) => {
  const { config1, configEcommerce } = useContext(UserConfigContext);
  const emailsSource = config1?.config_ecommerce?.emails_contactos || configEcommerce?.emails_contactos || [];
  const emails = (Array.isArray(emailsSource) ? emailsSource : String(emailsSource).split(/[;,]/))
    .map((email) => typeof email === "string" ? email.trim() : email?.email || email?.mail || email?.correo)
    .filter(Boolean);

  const showModal = () => {
    Swal.fire({
      icon: "info",
      title: modalTitle,
      text: emails.length
        ? `Comuníquese con nosotros a: ${emails.join(", ")}`
        : "Comuníquese con nosotros para consultar el precio.",
      confirmButtonText: "Entendido",
    });
  };

  return (
    <button type="button" onClick={showModal} className={className} title={modalTitle}>
      {children}
    </button>
  );
};

export default PriceConsultationButton;
